import React from 'react';

type SummaryModalRecordRowProps = {
  dateText: string;
  description: string;
  onClick: () => void;
};

const SummaryModalRecordRow = ({ dateText, description, onClick }: SummaryModalRecordRowProps) => (
  <button
    type="button"
    className="w-100 text-left border rounded p-3 mb-2 bg-white d-flex align-items-center"
    style={{ cursor: 'pointer' }}
    onClick={onClick}
  >
    <span className="text-nowrap mr-3 font-weight-medium">{dateText}</span>
    <span className="flex-grow-1 mx-2 text-break" style={{ minWidth: 0 }}>
      {description || '—'}
    </span>
    <i className="fas fa-chevron-right text-muted ml-2 flex-shrink-0" />
  </button>
);

export default SummaryModalRecordRow;
